import { SpaEntityType } from 'shared-types/Spa';

export type AdaptedExtra = {
  id: string | number;
  name: string;
  price?: { amount: number; currencyCode: string };
  featured?: boolean;
  extra?: { id: string | number };
};

export function adaptSpaExtras(spaEntity: SpaEntityType): AdaptedExtra[] {
  const allExtras: AdaptedExtra[] = [];
  const extras = spaEntity.extras || [];
  extras.forEach((ext: any) => {
    if (ext.options) {
      ext.options.forEach((option: any) => {
        allExtras.push({
          id: option.id,
          name: option.name,
          price: option.price,
          featured: option.featured,
          extra: { id: option.id },
        });
      });
    }
  });
  return allExtras.sort((a, b) => (b.featured ? 1 : 0) - (a.featured ? 1 : 0));
}

export function getExtraId(opt: AdaptedExtra): string | number {
  return opt.extra?.id || opt.id;
}

export function getExtraFieldKey(opt: AdaptedExtra): string {
  return `id-${getExtraId(opt)}`;
}
